<div class="tm-spinner-container" *ngIf="loading$ | async">
    <div class="spinner-mask logo-ar">
        <div class="spinner-img ">
            <span class="svg-icon" [svgIcon]="'logoAr'"></span>
        </div>
    </div>
    <div class="spinner-mask logo-en">
        <div class="spinner-img ">
            <span class="svg-icon" [svgIcon]="'logoEn'"></span>
        </div>
    </div>
</div>
<router-outlet></router-outlet>